import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import LockedDiv from '../../../common/locked-div/LockedDiv';
import Tab from '../../../common/tab';
import { getCurrentDate } from '../../../helpers/Common';
import withTabAndRealTime from '../common/withTabAndRealtime';
import { Provider } from '../../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../../common/ComponentNameContext';
import { indexMapFilter } from '../Const';
import AllExchanges from './AllExchanges';
import { connect } from 'react-redux';
import { exportTopLosersData, subscribeRealtimeTickTopLosers } from './reducer';
import ScrollComponent from './../../../common/ScrollComponent';
import { compose } from 'redux';
import PreRender from '../../../common/PreRender';
import ConstCommon from './../../../common/Const';
import Export from '../common/export-blob';
import TabTimer from '../../../common/tab-timer';

const listTab = {
  1: 'Overview',
  2: 'Performance',
  3: 'Financial',
  4: 'Technical',
  5: 'Chart',
};

class TopLosers extends Component {
  getExportFunction = () => {
    const { typeTab, indexTab, exportTopLosersData } = this.props;
    if (typeTab === 5) return;
    const screen = listTab[typeTab];
    const name = `${I18n.t(`common.export.topMover.${typeTab}`, {
      date: getCurrentDate(),
      name: I18n.t('common.listComponent.TopLosers'),
    })}`;
    exportTopLosersData(indexMapFilter[indexTab], screen, name);
  };

  render() {
    const { indexTab, changeIndex, typeTab, changeType, id } = this.props;

    return (
      <PreRender {...this.props}>
        <ComponentNameProvider value={ConstCommon.listComponent.TopLosers}>
          <Provider value={id}>
            <ScrollComponent>
              <div
                className={`top-nav d-flex flex-column ${
                  typeTab === 5 ? '' : 'h-100'
                }`}
              >
                <div className={`px-20 pt-8 ${typeTab === 5 ? 'sticky' : ''}`}>
                  <Tab
                    currentTab={indexTab}
                    listTab="topVolume.tab"
                    changeTab={changeIndex}
                  />

                  <div className="d-flex justify-content-between list-filter top-nav">
                    <TabTimer
                      currentTab={typeTab}
                      listTab="topVolume.tabDataChange.tabDataChangeTab"
                      changeTab={changeType}
                    />
                    <div style={{ paddingTop: 2 }}>
                      {typeTab !== 5 && (
                        <Export exportFunction={this.getExportFunction} />
                      )}
                    </div>
                  </div>
                </div>

                <div className="tab-content d-flex flex-fill flex-column">
                  <AllExchanges
                    key={indexTab}
                    indexTab={indexTab}
                    typeTab={typeTab}
                    filter={indexMapFilter[indexTab]}
                  />
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapStateToProps = state => ({ i18n: state.i18n });

const mapDispatchToProps = {
  dispatchRealtime: subscribeRealtimeTickTopLosers,
  exportTopLosersData,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withTabAndRealTime(ConstCommon.listComponent.TopLosers),
)(TopLosers);
